import { Button, Tooltip } from '@blueprintjs/core';
import PropTypes from 'prop-types';

const OpenDetailsButton = ({
  clickHandler = () => {},
  disabled = false,
  tooltipText = 'Click for detail view',
  paddingLeft = 10,
  paddingRight = 10,
}) => {
  return (
    <Tooltip minimal placement='bottom' content={tooltipText}>
      <Button
        minimal
        icon={'document-open'}
        style={{ paddingLeft, paddingRight }}
        onClick={clickHandler}
        disabled={disabled}
      />
    </Tooltip>
  );
};

OpenDetailsButton.propTypes = {
  clickHandler: PropTypes.func,
  disabled: PropTypes.bool,
  tooltipText: PropTypes.string,
  paddingLeft: PropTypes.number,
  paddingRight: PropTypes.number,
};

export default OpenDetailsButton;
